import { cn } from "@/lib/utils";

import type { ContentCollectMode } from "../collect-queries";

export const COLLECT_MODE_LABELS: Record<ContentCollectMode, string> = {
  "file-drop": "File drop",
  guided: "Guided",
};

/**
 * The neutral companion to `CollectStatusPill` — the list row and the detail
 * header both label the collect's mode, so the labels live in one place.
 */
export function CollectModePill({
  mode,
  className,
}: {
  mode: ContentCollectMode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex h-6 shrink-0 items-center rounded-full border border-neutral-200 bg-white px-2.5",
        "font-inter text-xs font-medium leading-none text-neutral-600",
        className
      )}
    >
      {COLLECT_MODE_LABELS[mode] ?? mode}
    </span>
  );
}
